import {ServerValueType} from '@/types/paramFilters/paramFilters'
import {TraitCategory, TraitCategoryOperator, TraitCategories} from '@/types/paramFilters/traitCategories'

/** Finds a server-provided trait category by its persisted category code. */
export const findTraitCategory = (categories: TraitCategories | undefined, categoryCode: string) => {
  return categories?.find(category => category.code === categoryCode)
}

/** Finds a server-provided trait within a category by its persisted trait code. */
export const findTrait = (categories: TraitCategories | undefined, categoryCode: string, traitCode: string) => {
  return findTraitCategory(categories, categoryCode)?.traits.find(trait => trait.code === traitCode)
}

/** Returns the server operator code without validating it against a static frontend list. */
export const getOperatorCode = (operatorCode: string): string => operatorCode

/** Returns the server value type for a trait operator without frontend remapping. */
export const getOperatorType = (operator: TraitCategoryOperator): ServerValueType => {
  const valueType = operator.value?.valueType

  if (operator.code === 'isYes' || operator.code === 'isNo') {
    return 'boolean'
  }

  if (
    valueType === 'number' ||
    valueType === 'date' ||
    valueType === 'string' ||
    valueType === 'textarea' ||
    valueType === 'singleSelect' ||
    valueType === 'multipleSelect' ||
    valueType === 'serverSingleSelect'
  ) {
    return valueType
  }

  throw new Error(`Unsupported trait category value type: ${valueType ?? 'null'}`)
}

export const getTraitCategoryDisplayName = (category: TraitCategory) => category.name
